// store/themeStore.js
import { defineStore } from "pinia";
import { useTheme, useDisplay } from "vuetify";
import { ref, computed } from "vue";

export const useThemeStore = defineStore("theme", () => {
  const theme = useTheme();
  const display = useDisplay();

  // ローカルストレージの値があれば取得、なければデフォルトはダークモード
  const isDarkMode = ref(
    localStorage.getItem("darkMode") !== null
      ? localStorage.getItem("darkMode") === "true"
      : true
  );

  // Vuetifyのテーマを初期設定
  theme.global.name.value = isDarkMode.value ? "dark" : "light";

  // テーマ切り替え関数
  const toggleTheme = () => {
    isDarkMode.value = !isDarkMode.value;
    localStorage.setItem("darkMode", isDarkMode.value);
    theme.global.name.value = isDarkMode.value ? "dark" : "light";
  };

  // モバイル判定（sm以下がtrue）
  const isMobile = computed(() => display.smAndDown.value);

  // ✅ 公開モード（/public/rooms/...）にアクセスしたかどうか
  const isPublicView = ref(false);

  const setPublicView = (flag = true) => {
    isPublicView.value = flag;
  };

  // ✅ メニューバー（AppBar/NavigationDrawer）を非表示にするかどうか
  const hideMenuBar = ref(false);

  const setHideMenuBar = (flag = true) => {
    hideMenuBar.value = flag;
  };

  return { isDarkMode, toggleTheme, isMobile, isPublicView, setPublicView, hideMenuBar, setHideMenuBar };
});
